import { Button, Center, Checkbox, Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';

export type THPXModulesManagementDataTableData = {
  primaryKey: string | number,
  identifier: string,
  name: string,
  isVisible: boolean,
  image: string,
  menu: string,
  icon: string,
  order: string | number,
  attachment: string,
  [x: string]: any,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any) => void,
};

const columnHelper = createColumnHelper<THPXModulesManagementDataTableData>();

export function getHPXModulesManagementDataTableColumns({
  isLoading,
  handleEdit,
}: Props) {
  return [
    columnHelper.accessor('identifier', {
      id: 'identifier',
      header: 'Identifiant',
      cell: (props) => {
        return (
            <Skeleton isLoaded={!isLoading}>
                <Center>{props.getValue()}</Center>
            </Skeleton>
        );
      },
    }),

    columnHelper.accessor('name', {
      id: 'name',
      header: 'Nom',
      cell: (props) => {
        return (
            <Skeleton isLoaded={!isLoading}>
                <Center>{props.getValue()}</Center>
            </Skeleton>
        );
      },
    }),

    columnHelper.accessor('isVisible', {
      id: 'isVisible',
      header: 'Visible',
      cell: (props) => {
        return (
            <Skeleton isLoaded={!isLoading}>
                <Center>
                    <Checkbox isChecked={!!props.getValue()} />
                </Center>
            </Skeleton>
        );
      },
    }),

    columnHelper.accessor('image', {
      id: 'image',
      header: 'Image',
      cell: (props) => {
        return (
            <Skeleton isLoaded={!isLoading}>
                <Center>{props.getValue()}</Center>
            </Skeleton>
        );
      },
    }),

    columnHelper.accessor('menu', {
      id: 'menu',
      header: 'Menu',
      cell: (props) => {
        return (
            <Skeleton isLoaded={!isLoading}>
                <Center>{props.getValue()}</Center>
            </Skeleton>
        );
      },
    }),

    columnHelper.accessor('icon', {
      id: 'icon',
      header: 'Icône',
      cell: (props) => {
        return (
            <Skeleton isLoaded={!isLoading}>
                <Center>{props.getValue()}</Center>
            </Skeleton>
        );
      },
    }),

    columnHelper.accessor('order', {
      id: 'order',
      header: 'Ordre',
      cell: (props) => {
        return (
            <Skeleton isLoaded={!isLoading}>
                <Center>{props.getValue()}</Center>
            </Skeleton>
        );
      },
    }),

    columnHelper.accessor('attachment', {
      id: 'attachment',
      header: 'Rattachement',
      cell: (props) => {
        return (
            <Skeleton isLoaded={!isLoading}>
                <Center>{props.getValue()}</Center>
            </Skeleton>
        );
      },
    }),


    columnHelper.display({
      id: 'action',
      header: '',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>
              <Button
                size={'sm'}
                onClick={() => handleEdit(props.row)}
                mr={'1rem'}
              >
                Editer
              </Button>
            </Center>
          </Skeleton>
        );
      },
    }),
  ];
}
